import fetchBuilder from 'fetch-retry';

// Use fail-safe fetch implementation
const fetch = fetchBuilder(global.fetch);

// Export a wrapped fetch with defaults applied
export default function failsafeFetch(url, options = {}) {
    let actualAttempt = 0;

    // Sensible default settings
    const defaultFetchSettings = {
        // count of retries
        retries: Number.MAX_SAFE_INTEGER,
        // function to determine the delay between retries
        // eslint-disable-next-line no-unused-vars
        retryDelay(attempt, error, response) {
            if (!window.navigator.onLine) {
                // we hope the system returns to be online again
                return 2000;
            }
            // eslint-disable-next-line no-plusplus
            actualAttempt++;
            return (1.2 ** actualAttempt) * 1000;
        },
        // status codes that cause a retry
        retryOn: [
            408, // Request Timeout
            418, // I'm a teapot
            /*500, // Internal Server Error -> bad idea, because it will repeat */
            503, // Service Unavailable
            504, // Gateway Timeout
        ],
        // should never apply, but to be on the safe side
        mode: 'same-origin'
    };

    // Merge default settings with request-specific overrides
    const finalOptions = {
        ...defaultFetchSettings,
        ...options,
    };

    // simulate a 404 if a URL out of tu-dresden.de is requested (last resort if something went wrong)
    const urlObj = new URL(url);
    if (urlObj.host !== window.location.host) {
        if (process.env.NODE_ENV !== 'production') {
            throw Error(`Unallowed cross-origin API call to ${urlObj.href}!`);
        }
        return Promise.resolve(new Response(new Blob(), { status: 404 }));
    }

    return fetch(url, finalOptions);
}
